import { render, staticRenderFns } from "./RepairFaultTypeList.vue?vue&type=template&id=40d3a38d"
import script from "./RepairFaultTypeList.vue?vue&type=script&lang=js"
export * from "./RepairFaultTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports